export const LAST_USED_ENTITY_ID = 'last-entity-id'
export const LAST_USED_ACCOUNT_ID = 'last-account-id'
export const WAS_CARD_PROMO_SHOWN = 'was-card-promo-shown'
export const WAS_LANG_PROMO_SHOWN = 'was-lang-promo-shown'
